// import styles from "../../../pages/ordermanager/Orders.module.css";

// const actionStyles = {
//   ADD: { color: "#297038", label: "Added" },
//   REMOVE: { color: "#f11717", label: "Removed" },
//   UPDATE: { color: "#b8860b", label: "Updated" },
//   UNCHANGED: { color: "#8a8a8a", label: "Unchanged" },
// };

// const fieldLabels = {
//   qty: "Qty",
//   price: "Rate",
//   desc: "Description",
//   unit: "Unit",
//   batch: "Batch",
//   status: "Status",
//   itemQueue: "Queue",
//   specific: "Specific",
// };

// const ChangeChip = ({ change, mode }) => {
//   const label = fieldLabels[change.field] || change.field;
//   const isNumeric =
//     typeof change.to === "number" && typeof change.from === "number";

//   if (isNumeric) {
//     const increased = change.to > change.from;
//     const deltaColor = increased ? "#297038" : "#f11717";
//     const delta =
//       change.delta ||
//       (increased
//         ? `+${change.to - change.from}`
//         : `${change.to - change.from}`);

//     return (
//       <span
//         style={{
//           display: "inline-flex",
//           alignItems: "center",
//           gap: "4px",
//           fontSize: "11px",
//           padding: "2px 8px",
//           borderRadius: "10px",
//           backgroundColor: mode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
//           color: mode ? "#fff" : "#1C274C",
//           marginRight: "6px",
//           marginTop: "4px",
//         }}
//       >
//         <b>{label}:</b>
//         <span>{change.to}</span>
//         <span style={{ color: deltaColor, fontWeight: 700 }}>[{delta}]</span>
//       </span>
//     );
//   }

//   // Text field: old in red strikethrough, new in green
//   return (
//     <span
//       style={{
//         display: "inline-flex",
//         alignItems: "center",
//         gap: "4px",
//         fontSize: "11px",
//         padding: "2px 8px",
//         borderRadius: "10px",
//         backgroundColor: mode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
//         marginRight: "6px",
//         marginTop: "4px",
//       }}
//     >
//       <b style={{ color: mode ? "#fff" : "#1C274C" }}>{label}:</b>
//       <span style={{ textDecoration: "line-through", color: "#f11717" }}>
//         {change.from}
//       </span>
//       <span style={{ color: mode ? "#fff" : "#1C274C" }}>→</span>
//       <span style={{ color: "#297038", fontWeight: 700 }}>{change.to}</span>
//     </span>
//   );
// };

// const DataItemListProAndSale = ({
//   index,
//   d,
//   mode,
//   voucherType,
//   selectedVersion,
//   isLiveEditingItems,
// }) => {
//   const style = mode ? { backgroundColor: "#232529" } : {};
//   const showVersionInfo = !isLiveEditingItems && selectedVersion;
//   const actionMeta = actionStyles[d.action] || {};

//   console.log("Items Data", d);

//   return (
//     <>
//       <li
//         className={`${styles.p_table_row} ${styles.hide_760px} ${
//           mode ? styles.p_table_row_dark : ""
//         }`}
//         style={
//           showVersionInfo
//             ? {
//                 // borderLeft: `3px solid ${actionMeta.color || "transparent"}`,
//                 backgroundColor:
//                   d.action === "REMOVE"
//                     ? mode
//                       ? "rgba(241, 23, 23, 0.23)"
//                       : "rgba(241, 23, 23, 0.23)"
//                     : d.action === "ADD"
//                       ? mode
//                         ? "rgba(41, 112, 56, 0.26)"
//                         : "rgba(41, 112, 56, 0.26)"
//                       : d.action === "UPDATE"
//                         ? mode
//                           ? "rgba(241, 190, 22, 0.26)"
//                           : "rgba(241, 190, 22, 0.26)"
//                         : undefined,
//               }
//             : undefined
//         }
//       >
//         <div className={styles.entry_2}> {index + 1} </div>
//         <div className={styles.entry_2}>{d.itemNo}</div>
//         {d.product_name && (
//           <div className={styles.entry_2}> {d.product_name || "-"} </div>
//         )}
//         {d.collection_name && (
//           <div className={styles.entry_2}> {d.collection_name || "-"} </div>
//         )}

//         <div className={styles.entry_2}>{d.qty}</div>
//         <div className={styles.entry_2}> {d.unit}</div>
//         <div className={styles.entry_2}> {d.price}</div>
//         <div className={styles.entry_2}> {d.price * d.qty}</div>

//         {showVersionInfo && (
//           <div
//             style={{
//               color: actionMeta.color,
//               fontWeight: 600,
//             }}
//             className={styles.entry_2}
//           >
//             {d.action}
//           </div>
//         )}
//       </li>

//       {d.desc !== "" ? (
//         <div style={mode ? { color: "#ffffff" } : {}} className={styles.desc}>
//           {d.desc}
//         </div>
//       ) : null}

//       {/* ── What changed in this version ──────────────────────────────── */}
//       {showVersionInfo && d.action === "UPDATE" && d.changes?.length > 0 && (
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             padding: "4px 8px 8px",
//           }}
//         >
//           {d.changes.map((change, i) => (
//             <ChangeChip key={i} change={change} mode={mode} />
//           ))}
//         </div>
//       )}
//       {/*
//       {showVersionInfo && d.action === "ADD" && (
//         <div
//           style={{
//             fontSize: "11px",
//             color: "#297038",
//             fontWeight: 600,
//             padding: "2px 8px 8px",
//           }}
//         >
//           New item added to the order
//         </div>
//       )}

//       {showVersionInfo && d.action === "REMOVE" && (
//         <div
//           style={{
//             fontSize: "11px",
//             color: "#f11717",
//             fontWeight: 600,
//             padding: "2px 8px 8px",
//           }}
//         >
//           Item removed from the order
//         </div>
//       )} */}

//       <div
//         className={`${styles.show_760px} ${mode ? styles.show_760px_dark : ""}`}
//         style={{ marginTop: "0.25rem" }}
//       >
//         <div className={styles.show_760px_1}>
//           <p style={mode ? { color: "#FFFFFF" } : {}}>
//             <span>{index + 1}.</span> Item Information{" "}
//           </p>
//         </div>
//         <div className={`${styles.show_760px_2}`} style={style}>
//           <div>
//             <p>{d.itemNo}</p>
//           </div>
//           <div>
//             <p>{d.product_name}</p>
//           </div>
//           <div>
//             <p>{d.warehouse}</p>
//           </div>
//         </div>
//         <div className={styles.show_760px_3}>
//           <div className={styles.element}>
//             <p>Qty</p>
//             <div style={style}>
//               <p>{d.qty}</p>
//             </div>
//           </div>
//           <div className={styles.element}>
//             <p>Unit</p>
//             <div style={style}>
//               <p>{d.unit}</p>
//             </div>
//           </div>
//           <div className={styles.element}>
//             <p>Rate</p>
//             <div style={style}>
//               <p>{d.price}</p>
//             </div>
//           </div>
//           <div className={styles.element}>
//             <p>Amount</p>
//             <div style={style}>
//               <p>{d.price * d.qty}</p>
//             </div>
//           </div>
//         </div>
//         {d.desc !== "" ? (
//           <div style={style} className={styles.show_760px_4}>
//             {d.desc}
//           </div>
//         ) : null}

//         {showVersionInfo && (
//           <div style={{ padding: "4px 8px" }}>
//             <span
//               style={{ color: actionMeta.color, fontWeight: 600, fontSize: 12 }}
//             >
//               {d.action}
//             </span>
//             {d.action === "UPDATE" && d.changes?.length > 0 && (
//               <div style={{ display: "flex", flexWrap: "wrap", marginTop: 4 }}>
//                 {d.changes.map((change, i) => (
//                   <ChangeChip key={i} change={change} mode={mode} />
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default DataItemListProAndSale;

import styles from "../../../pages/ordermanager/Orders.module.css";

const actionStyles = {
  ADD: { color: "#297038", label: "Added" },
  REMOVE: { color: "#f11717", label: "Removed" },
  UPDATE: { color: "#b8860b", label: "Updated" },
  UNCHANGED: { color: "#8a8a8a", label: "Unchanged" },
};

// Helper: find a change entry for a given field
const getChange = (changes, field) => changes?.find((c) => c.field === field);

// Renders a numeric cell value with inline delta, e.g. 5[+3]
const NumericCell = ({ value, change }) => {
  if (!change) return <>{value}</>;
  const increased = change.to > change.from;
  const deltaColor = increased ? "#297038" : "#f11717";
  const delta =
    change.delta ||
    (increased ? `+${change.to - change.from}` : `${change.to - change.from}`);

  return (
    <>
      {value}
      <span style={{ color: deltaColor, fontWeight: 700, marginLeft: 3 }}>
        [{delta}]
      </span>
    </>
  );
};

// Renders a text cell with old struck-through in red, new in green
const TextCell = ({ value, change }) => {
  if (!change) return <>{value}</>;
  return (
    <>
      <span style={{ textDecoration: "line-through", color: "#f11717" }}>
        {change.from}
      </span>{" "}
      <span style={{ color: "#297038", fontWeight: 700 }}>{change.to}</span>
    </>
  );
};

const DataItemListProAndSale = ({
  index,
  d,
  mode,
  voucherType,
  selectedVersion,
  isLiveEditingItems,
}) => {
  const style = mode ? { backgroundColor: "#232529" } : {};
  const showVersionInfo = !isLiveEditingItems && selectedVersion;
  const actionMeta = actionStyles[d.action] || {};

  const isUpdate = showVersionInfo && d.action === "UPDATE";
  const qtyChange = isUpdate ? getChange(d.changes, "qty") : null;
  const priceChange = isUpdate ? getChange(d.changes, "price") : null;
  const descChange = isUpdate ? getChange(d.changes, "desc") : null;
  const unitChange = isUpdate ? getChange(d.changes, "unit") : null;

  return (
    <>
      <li
        className={`${styles.p_table_row} ${styles.hide_760px} ${
          mode ? styles.p_table_row_dark : ""
        }`}
        style={
          showVersionInfo
            ? {
                backgroundColor:
                  d.action === "REMOVE"
                    ? "rgba(241, 23, 23, 0.23)"
                    : d.action === "ADD"
                      ? "rgba(41, 112, 56, 0.26)"
                      : d.action === "UPDATE"
                        ? "rgba(241, 190, 22, 0.26)"
                        : undefined,
              }
            : undefined
        }
      >
        <div className={styles.entry_2}> {index + 1} </div>
        <div className={styles.entry_2}>{d.itemNo}</div>
        {d.product_name && (
          <div className={styles.entry_2}> {d.product_name || "-"} </div>
        )}
        {d.collection_name && (
          <div className={styles.entry_2}> {d.collection_name || "-"} </div>
        )}

        <div className={styles.entry_2}>
          <NumericCell value={d.qty} change={qtyChange} />
        </div>
        <div className={styles.entry_2}>
          <TextCell value={d.unit} change={unitChange} />
        </div>
        <div className={styles.entry_2}>
          <NumericCell value={d.price} change={priceChange} />
        </div>
        <div className={styles.entry_2}> {d.price * d.qty}</div>

        {showVersionInfo && (
          <div
            style={{ color: actionMeta.color, fontWeight: 600 }}
            className={styles.entry_2}
          >
            {d.action}
          </div>
        )}
      </li>

      {d.desc !== "" ? (
        <div style={mode ? { color: "#ffffff" } : {}} className={styles.desc}>
          {isUpdate ? <TextCell value={d.desc} change={descChange} /> : d.desc}
        </div>
      ) : null}

      <div
        className={`${styles.show_760px} ${mode ? styles.show_760px_dark : ""}`}
        style={{ marginTop: "0.25rem" }}
      >
        <div className={styles.show_760px_1}>
          <p style={mode ? { color: "#FFFFFF" } : {}}>
            <span>{index + 1}.</span> Item Information{" "}
          </p>
        </div>
        <div className={`${styles.show_760px_2}`} style={style}>
          <div>
            <p>{d.itemNo}</p>
          </div>
          <div>
            <p>{d.product_name}</p>
          </div>
          <div>
            <p>{d.warehouse}</p>
          </div>
        </div>
        <div className={styles.show_760px_3}>
          <div className={styles.element}>
            <p>Qty</p>
            <div style={style}>
              <p>
                <NumericCell value={d.qty} change={qtyChange} />
              </p>
            </div>
          </div>
          <div className={styles.element}>
            <p>Unit</p>
            <div style={style}>
              <p>
                <TextCell value={d.unit} change={unitChange} />
              </p>
            </div>
          </div>
          <div className={styles.element}>
            <p>Rate</p>
            <div style={style}>
              <p>
                <NumericCell value={d.price} change={priceChange} />
              </p>
            </div>
          </div>
          <div className={styles.element}>
            <p>Amount</p>
            <div style={style}>
              <p>{d.price * d.qty}</p>
            </div>
          </div>
        </div>
        {d.desc !== "" ? (
          <div style={style} className={styles.show_760px_4}>
            {isUpdate ? (
              <TextCell value={d.desc} change={descChange} />
            ) : (
              d.desc
            )}
          </div>
        ) : null}

        {showVersionInfo && (
          <div style={{ padding: "4px 8px" }}>
            <span
              style={{ color: actionMeta.color, fontWeight: 600, fontSize: 12 }}
            >
              {d.action}
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default DataItemListProAndSale;
